import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { NullBody1903zz7riiwr0 as NullBody } from '../../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance_0,
} from '../../statement/HttpResponsePipeline.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TransformRequestBodyContextClass;
function TransformRequestBodyContext() {
  if (TransformRequestBodyContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TransformRequestBodyContext');
    TransformRequestBodyContextClass = $;
  }
  return TransformRequestBodyContextClass;
}
var TransformResponseBodyContextClass;
function TransformResponseBodyContext() {
  if (TransformResponseBodyContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TransformResponseBodyContext');
    TransformResponseBodyContextClass = $;
  }
  return TransformResponseBodyContextClass;
}
var OnRequestContextClass;
function OnRequestContext() {
  if (OnRequestContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'OnRequestContext');
    OnRequestContextClass = $;
  }
  return OnRequestContextClass;
}
var RequestHook$install$slambdaClass;
function RequestHook$install$slambda() {
  if (RequestHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.d5v_1 = $handler;
      }
      *r5f($this$intercept, it, $completion) {
        yield* this.d5v_1(new (OnRequestContext())(), $this$intercept.g4r_1, $this$intercept.h4q(), $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.r5f(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    RequestHook$install$slambdaClass = $;
  }
  return RequestHook$install$slambdaClass;
}
function RequestHook$install$slambda_0($handler) {
  var i = new (RequestHook$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.r5f($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var RequestHookClass;
function RequestHook() {
  if (RequestHookClass === VOID) {
    class $ {
      e5v(client, handler) {
        var tmp = Phases_getInstance().j5m_1;
        client.y5f_1.k4r(tmp, RequestHook$install$slambda_0(handler));
      }
      n5m(client, handler) {
        return this.e5v(client, (!(handler == null) ? isSuspendFunction(handler, 3) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestHook');
    RequestHookClass = $;
  }
  return RequestHookClass;
}
var RequestHook_instance;
function RequestHook_getInstance() {
  return RequestHook_instance;
}
var TransformRequestBodyHook$install$slambdaClass;
function TransformRequestBodyHook$install$slambda() {
  if (TransformRequestBodyHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.f5v_1 = $handler;
      }
      *r5f($this$intercept, it, $completion) {
        var newContent = yield* this.f5v_1(new (TransformRequestBodyContext())(), $this$intercept.g4r_1, $this$intercept.h4q(), $this$intercept.g4r_1.g5v(), $completion);
        if (!(newContent == null)) {
          yield* $this$intercept.i4q(newContent, $completion);
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.r5f(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    TransformRequestBodyHook$install$slambdaClass = $;
  }
  return TransformRequestBodyHook$install$slambdaClass;
}
function TransformRequestBodyHook$install$slambda_0($handler) {
  var i = new (TransformRequestBodyHook$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.r5f($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var TransformRequestBodyHookClass;
function TransformRequestBodyHook() {
  if (TransformRequestBodyHookClass === VOID) {
    class $ {
      h5v(client, handler) {
        var tmp = Phases_getInstance().k5m_1;
        client.y5f_1.k4r(tmp, TransformRequestBodyHook$install$slambda_0(handler));
      }
      n5m(client, handler) {
        return this.h5v(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TransformRequestBodyHook');
    TransformRequestBodyHookClass = $;
  }
  return TransformRequestBodyHookClass;
}
var TransformRequestBodyHook_instance;
function TransformRequestBodyHook_getInstance() {
  return TransformRequestBodyHook_instance;
}
var TransformResponseBodyHook$install$slambdaClass;
function TransformResponseBodyHook$install$slambda() {
  if (TransformResponseBodyHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.i5v_1 = $handler;
      }
      *o5g($this$intercept, it, $completion) {
        var _destruct__k2r9zo = $this$intercept.h4q();
        var typeInfo = _destruct__k2r9zo.we();
        var content = _destruct__k2r9zo.xe();
        if (!isInterface(content, ByteReadChannel()))
          return Unit_instance;
        var tmp0_elvis_lhs = yield* this.i5v_1(new (TransformResponseBodyContext())(), $this$intercept.g4r_1.l5g(), content, typeInfo, $completion);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var newContent = tmp;
        var tmp_0;
        if (!(newContent instanceof NullBody())) {
          tmp_0 = !typeInfo.y4r_1.ze(newContent);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          throw IllegalStateException().o('transformResponseBody returned ' + toString(newContent) + ' but expected value of type ' + typeInfo.toString());
        }
        yield* $this$intercept.i4q(new (HttpResponseContainer())(typeInfo, newContent), $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.o5g(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    TransformResponseBodyHook$install$slambdaClass = $;
  }
  return TransformResponseBodyHook$install$slambdaClass;
}
function TransformResponseBodyHook$install$slambda_0($handler) {
  var i = new (TransformResponseBodyHook$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.o5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var TransformResponseBodyHookClass;
function TransformResponseBodyHook() {
  if (TransformResponseBodyHookClass === VOID) {
    class $ {
      j5v(client, handler) {
        var tmp = Phases_getInstance_0().k5h_1;
        client.z5f_1.k4r(tmp, TransformResponseBodyHook$install$slambda_0(handler));
      }
      n5m(client, handler) {
        return this.j5v(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TransformResponseBodyHook');
    TransformResponseBodyHookClass = $;
  }
  return TransformResponseBodyHookClass;
}
var TransformResponseBodyHook_instance;
function TransformResponseBodyHook_getInstance() {
  return TransformResponseBodyHook_instance;
}
//region block: init
RequestHook_instance = new (RequestHook())();
TransformRequestBodyHook_instance = new (TransformRequestBodyHook())();
TransformResponseBodyHook_instance = new (TransformResponseBodyHook())();
//endregion
//region block: exports
export {
  RequestHook_instance as RequestHook_instancekg84gatwz31z,
  TransformRequestBodyHook_instance as TransformRequestBodyHook_instance124n1iui3hxhd,
  TransformResponseBodyHook_instance as TransformResponseBodyHook_instance1qpxtjyk29394,
  OnRequestContext as OnRequestContext1tmu5b6bhlblg,
  TransformRequestBodyContext as TransformRequestBodyContext3ll40opqaho0d,
  TransformResponseBodyContext as TransformResponseBodyContext1axf7xx6ifwbj,
};
//endregion

//# sourceMappingURL=KtorCallContexts.mjs.map
